// extracted by mini-css-extract-plugin
export default {"upload__evidence--container":"PaymentEvidence_upload__evidence--container__PJcbH"};